import React from "react";
import { PageShell, EditableSection } from "./PageShell";
import { usePageFeatures } from "@/lib/siteContent";

const DEFAULT_ZONES = [
  { z: "Within Canada", d: "3–6 business days", p: "Free over CA$120 · flat rate below" },
  { z: "United States", d: "5–8 business days", p: "Rate calculated at checkout" },
  { z: "International", d: "Contact us", p: "International shipping is being expanded — please write to us for a quote to your country" },
];

const PROCESSING = [{
  heading: "Order processing",
  body: "Orders placed before 2pm Pacific Monday–Friday are typically dispatched the same day. Orders that include engraving add 2–3 business days of studio time before dispatch. You’ll receive a tracking link by email as soon as your parcel is scanned by the courier.",
}];

const METHODS = [{
  heading: "Shipping methods",
  body: "Canadian orders ship via Canada Post or courier depending on destination and parcel weight. International orders ship via major couriers (rates and options shown at checkout). Every parcel is trackable end-to-end.",
}];

const TRACKING = [{
  heading: "Tracking your parcel",
  body: "A tracking link is emailed automatically when your parcel is picked up. If you can’t find the email, use our Track Your Order page with your order number and the email address used at checkout.",
}];

const DELAYS = [{
  heading: "Delays & holidays",
  body: "Courier estimates are best guesses — not guarantees. Delays occasionally happen due to weather, courier volume, or customs. If your parcel hasn’t moved for 5 business days, contact our concierge and we’ll investigate with the courier.",
}];

const DAMAGED = [{
  heading: "Damaged package procedure",
  body: "If your order arrives damaged, please email a photo of the parcel and the bottle within 7 days of delivery. We’ll ship a replacement at our cost — no forms, no back-and-forth.",
}];

export default function ShippingPage() {
  const shopifyZones = usePageFeatures("shipping", "zones");
  const zones = shopifyZones.length > 0
    ? shopifyZones.map((z) => ({ z: z.badge || z.title, d: z.title || "", p: z.body || "" }))
    : DEFAULT_ZONES;

  return (
    <PageShell
      slug="shipping"
      testid="shipping"
      eyebrow="Shipping & Delivery"
      title="Every parcel, tracked & insured."
      intro="Scentodore ships from our Canadian atelier. Orders are tracked end-to-end, and we monitor every parcel until it reaches your door."
    >
      <div className="mb-14">
        <h2 className="font-serif text-xl sm:text-2xl text-[#1A1918] mb-4">Rates & timelines</h2>
        <div className="overflow-x-auto rounded-2xl border border-black/10">
          <table className="w-full text-sm">
            <thead className="bg-[#F1ECE4]/60">
              <tr className="text-left uppercase tracking-[0.14em] text-[10px] text-[#1A1918]/60">
                <th className="px-5 py-3">Region</th>
                <th className="px-5 py-3">Estimated delivery</th>
                <th className="px-5 py-3">Cost</th>
              </tr>
            </thead>
            <tbody>
              {zones.map((z, i) => (
                <tr key={i} className="border-t border-black/5">
                  <td className="px-5 py-4 font-serif text-[15px]">{z.z}</td>
                  <td className="px-5 py-4 text-[#1A1918]/75">{z.d}</td>
                  <td className="px-5 py-4 text-[#1A1918]/75">{z.p}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <EditableSection slug="shipping" sectionKey="processing" fallback={PROCESSING} />
      <EditableSection slug="shipping" sectionKey="methods" fallback={METHODS} />
      <EditableSection slug="shipping" sectionKey="tracking" fallback={TRACKING} />
      <EditableSection slug="shipping" sectionKey="delays" fallback={DELAYS} />
      <EditableSection slug="shipping" sectionKey="damaged" fallback={DAMAGED} />
    </PageShell>
  );
}
